import React from 'react';
import { Spin, Typography } from 'antd';
import ClassifiedCarCards from '../ClassifiedCarCards/ClassifiedCarCards';
import { Car } from '../../types/home';

const { Title } = Typography;

interface ClassifiedsSectionProps {
  loading: boolean;
  error: string | null;
  cars: Array<Car>;
  carsLength: number;
  starToggle: string;
  setStarChanged: (starChanged: boolean) => void;
  setDataSource: (cars: Array<Car>) => void;
  onNavigateToDetails: () => void;
}

const ClassifiedsSection: React.FC<ClassifiedsSectionProps> = ({
  loading,
  error,
  cars,
  carsLength,
  starToggle,
  setStarChanged,
  setDataSource,
  onNavigateToDetails
}) => {
  return (
    <div className="car-cards-wrapper">
      <Title level={2} className="section-header">
        Classifieds
      </Title>
      {loading ? (
        <div className="loading-spinner">
          <Spin tip="Loading classifieds..." />
        </div>
      ) : (
        <ClassifiedCarCards
          page={1}
          itemsPerPage={6}
          dataSource={cars}
          carsLength={carsLength}
          onPageChange={() => {}}
          setDataSource={setDataSource}
          starToggle={starToggle}
          setStarChanged={setStarChanged}
          onNavigateToDetails={onNavigateToDetails}
          pages={false}
        />
      )}
    </div>
  );
};

export default ClassifiedsSection;
